import React from "react";

export default function History_Numbers() {
  return (
    <div>
      <h1>History_Numbers</h1>
      <p>This is the History_Numbers component.</p>
    </div>
  );
}
